import React from 'react';

const SidebarNavContext = React.createContext(null);

export default SidebarNavContext;


// WEBPACK FOOTER //
// ./src/lib/SidebarNavContext/index.js